<template>
    <div class="product-sticker-wrapper">
        <ul class="product-sticker-list" v-if="collectionInput === true">
            <li
                class="product-sticker text-uppercase"
                v-for="sticker in cmsStickersFiltered"
                v-bind:style="{
                    color: sticker.color,
                    border: '1px solid' + sticker.color,
                }"
                :key="sticker.id"
            >
                <span
                    v-if="sticker.current_lang_translations[0].special_title !== null"
                    v-html="sticker.current_lang_translations[0].special_title"
                />
                <span v-else v-html="sticker.current_lang_translations[0].title" />
            </li>
        </ul>
        <ul
            class="product-sticker-list"
            v-else-if="arrayInput === false && collectionInput === false && cmsStickersFiltered[0].current_lang_translation"
        >
            <li
                class="product-sticker text-uppercase"
                v-bind:style="{
                    color: sticker.color,
                    border: '1px solid' + sticker.color,
                }"
                v-for="sticker in cmsStickersFiltered"
                :key="sticker.id"
            >
                <span v-if="sticker.current_lang_translation.special_title === null">
                    {{ sticker.current_lang_translation.title }}
                </span>
                <span v-else>
                    {{ sticker.current_lang_translation.special_title }}
                </span>
            </li>
        </ul>
        <ul
            class="product-sticker-list"
            v-else-if="arrayInput === false && collectionInput === false && cmsStickersFiltered[0].translations"
        >
            <li
                class="product-sticker text-uppercase"
                v-bind:style="{
                    color: sticker.color,
                    border: '1px solid' + sticker.color,
                }"
                v-for="sticker in cmsStickersFiltered"
                :key="sticker.id"
            >
                <span v-if="sticker.translations[0].special_title === null">
                    {{ sticker.translations[0].title }}
                </span>
                <span v-else>
                    {{ sticker.translations[0].special_title }}
                </span>
            </li>
        </ul>
        <ul v-else class="product-sticker-list">
            <li
                class="product-sticker text-uppercase"
                v-for="(sticker, index) in cmsStickersFiltered"
                :key="sticker.id"
                v-bind:style="[
                    specialColor != null && index == 0 ? {} : { color: specialColor, border: '1px solid' + specialColor },
                ]"
            >
                <span v-html="sticker" :title="stickerForTitle(sticker)"> </span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        cmsStickers: [],
        specialColor: {},
        watchdog: {
            default: false,
        },
        arrayInput: {
            default: false,
        },
        collectionInput: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            cmsStickersFiltered: [],
        };
    },

    created() {
        // Filter out stickers which should not be shown, regardless of the input type
        this.cmsStickersFiltered = this.cmsStickers.filter(cmsSticker => cmsSticker?.show_as_text !== 0);

      //   if (this.watchdog || this.arrayInput || this.collectionInput) {
      //       this.cmsStickersFiltered = this.cmsStickers;
      //   } else {
      //       this.cmsStickersFiltered = this.cmsStickers.filter(sticker => {
      //           if (!sticker.code) return true;
      //           if (sticker.code == 'stUniv1') return true;
      //           if (sticker.code == 'stUniv3') return true;
      //           if (sticker.code?.includes('stUniv')) return false;
      //           return true;
      //       });
      //   }
    },

    methods: {
        stickerForTitle(sticker) {
            let tempSticker = sticker.replace('<span class="dec-point">', '');
            tempSticker = tempSticker.replace('</span>', '');
            return tempSticker;
        },
    },
};
</script>
